import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { useForm } from "@mantine/form";
import { IconPlus, IconSearch, IconTrash } from "@tabler/icons-react";

import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconEdit } from "@tabler/icons-react";
import {
  repositoryDelivery,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { _localization } from "../../../config/location";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { MessageResponse } from "../../../model/MessageResponse";
import { ReturnTechnicalExchangeEntityModel } from "../../../model/ReturnTechnicalExchange";
import CreateReturnTechnicalExchange from "./CreateReturnTechnicalExchange";

const ReturnTechnicalExchange = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<ReturnTechnicalExchangeEntityModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 25,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 3, xl: 2 };
  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
    []
  );
  const [dataBranchCodee, setDataBranchCodee] = useState<SelectListItemBase[]>(
    []
  ); // Danh sách chi nhánh

  const [selectIds, setSelectIds] = useState<string[]>([]);
  const formSeachInput = useForm<{
    keySearch: string | null; // từ khoá tìm kiếm
    type: number | null; // 1:cấp mức 1, 2:cấp mức 2
    empId: number | null; // id nhân viên
  }>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: "",
      type: null,
      empId: null,
    },
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    try {
      let url = `/api/v1/AuthApproveKT/get-list?Skip=${pagination.pageIndex * pagination.pageSize
        }&Take=${pagination.pageSize}`;

      const keySearch = {
        keySearch: formSeachInput.getValues().keySearch || "",
        type: formSeachInput.getValues().type || null,
        empId: formSeachInput.getValues().empId || null,
      };
      Object.entries(keySearch).forEach(([key, value]) => {
        if (value) {
          url += `&${key}=${encodeURIComponent(value)}`;
        }
      });
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        // console.log("Response data:", response);
        const result = response.data;
        setData(result);
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const columns = React.useMemo<
    MRT_ColumnDef<ReturnTechnicalExchangeEntityModel>[]
  >(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 80,
      },
      {
        accessorKey: "empName",
        header: "Tên nhân viên",
        size: 250,
        Cell: ({ renderedCellValue }) => {
          return (
            <Badge color="blue" variant="light" radius="sm">
              {renderedCellValue}
            </Badge>
          );
        },
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 250,
      },
      // {
      //   accessorKey: "typeAtuh",
      //   header: "Mức cấp",
      //   size: 250,
      //   Cell: ({ renderedCellValue }) => {
      //     const isCap1 = renderedCellValue === 1 || renderedCellValue === "1";
      //     return (
      //       <Badge
      //         color={isCap1 ? "blue" : "orange"}
      //         variant="light"
      //         radius="sm"
      //       >
      //         {isCap1 ? "Cấp 1" : "Cấp 2"}
      //       </Badge>
      //     );
      //   },
      // },
      {
        accessorKey: "listOrgId",
        header: "Chi nhánh",
        size: 400,
        Cell: ({ renderedCellValue }) => {
          const branchIds = dataBranchCodee
            .filter((item: any) => item?.text !== null && item?.value !== null)
            .map((item: any) => item.value?.toString());
          console.log("branchIds:", branchIds);
          const listOrgIdArr = String(renderedCellValue ?? "")
            .split(",")
            .filter((id) => id.trim() !== "");

          // Nếu tất cả chi nhánh đều có trong listOrgIdArr thì hiển thị "Tất cả"
          const isAllSelected =
            branchIds.length > 0 &&
            branchIds.every((value) => listOrgIdArr.includes(value));

          if (isAllSelected) {
            return (
              <Badge color="blue" variant="light" radius="sm">
                Tất cả
              </Badge>
            );
          }

          const matchedBranches = dataBranchCodee.filter(
            (item: any) =>
              item?.text !== null &&
              item?.value !== null &&
              listOrgIdArr.includes(item.value?.toString())
          );
          return (
            <div>
              {matchedBranches.length > 0
                ? matchedBranches.map((branch: any) => (
                  <Badge
                    key={branch.text}
                    color="dark"
                    variant="light"
                    radius="sm"
                    mr={4}
                  >
                    {`[${branch.value}] - ${branch.text}`}
                  </Badge>
                ))
                : null}
            </div>
          );
        },
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 80,
        enableResizing: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <Flex justify={"center"} gap={10} align="center">
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                onClick={async () => {
                  handleOpenModalCreate(row.original);
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                onClick={() => {
                  modals.openConfirmModal({
                    title: (
                      <>
                        <Title order={5} fw={700}>
                          Bạn có chắc chắn muốn xóa phân quyền này không?
                        </Title>
                      </>
                    ),
                    labels: { confirm: "Xác nhận", cancel: "Hủy" },
                    confirmProps: { color: "red" },
                    onConfirm: () => handleDelete([row.original.id]),
                  });
                }}
                aria-label="Settings"
                color="red"
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [dataBranchCodee]
  );
  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enablePagination: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-expand", "ma_Ct"],
        right: ["action"],
      },
      // columnVisibility: { id: true },
      density: "xs",
      pagination: {
        pageSize: 50,
        pageIndex: 0,
      },
    },
    enableStickyFooter: true,
    enableToolbarInternalActions: false,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
  });
  // Lấy danh sách nhân viên
  const getDataEmployee = async () => {
    const response = await repositoryPos.get(`api/v1/TblDmEmployee/get-select`);
    if (response && response.success) {
      const data = response.data;
      const formattedData = data
        .map((item: any) => ({
          ...item,
          att1: Number(item.att1),
        }))
        .filter(
          (item: any) => typeof item.att1 === "number" && !isNaN(item.att1)
        )
        .map((item: any) => ({
          value: item.value,
          label: `${item.att1}-${item.text}`,
        }));
      setDataEmployeeSelect(formattedData);
    } else {
      setDataEmployeeSelect([]);
    }
  };

  //   Mở modal tạo mới
  const handleOpenModalCreate = (
    itemEdit?: ReturnTechnicalExchangeEntityModel
  ) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>
            {itemEdit
              ? "Cập nhật phân quyền duyệt kỹ thuật đổi trả"
              : "Tạo mới phân quyền duyệt kỹ thuật đổi trả"}
          </Title>
        </>
      ),
      size: "500px",
      children: (
        <CreateReturnTechnicalExchange
          fetchData={fetchData}
          itemEdit={itemEdit}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Hàm xóa
  const handleDelete = async (ids: string[]) => {
    if (ids.length === 0) return;
    open();
    try {
      const response = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/AuthApproveKT/remove`,
        ids // <-- truyền mảng chuỗi
      );
      if (response && response.success) {
        fetchData();
        NotificationExtension.Success("Đã xóa thành công!");
      }
    } catch (error) {
      console.error("Error deleting data:", error);
    } finally {
      close();
    }
  };

  //  lấy danh sách phòng ban
  // const DataDepartmentCode = async () => {
  //   try {
  //     // const response = await repositoryPos.get<
  //     //   MessageResponse<SelectListItemBase[]>
  //     // >(`/api/v1/TblDepartment/get-select?branchId=0&isShipping=false`);
  //     const response = await repositoryPos.get<
  //       MessageResponse<SelectListItemBase[]>
  //     >(`/api/v1/TblDepartment/get-all`);
  //     console.log("response", response);
  //     if (response && response.success) {
  //       const data = response.data;
  //       setDataDepartment(data);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     return;
  //   }
  // };

  //  lấy danh sách chi nhánh
  const DataBranchCode = async () => {
    try {
      const response = await repositoryDelivery.get<
        MessageResponse<SelectListItemBase[]>
      >(`/api/v1/TblDmMasterOrg/get-select`);
      // console.log("response", response);
      if (response && response.success) {
        const data = response.data;
        setDataBranchCodee(data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  useEffect(() => {
    const run = async () => {
      // await DataBranchCode();
      await DataBranchCode();
      // await getDataEmployee();
      await fetchData();
    };
    run();
  }, [pagination]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />

      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
        }}
        ref={headerRef}
      >
        <Group justify="space-between">
          <BreadcrumbLayout1></BreadcrumbLayout1>
        </Group>
        <Grid>
          <Grid.Col span={{ base: 12, sm: 10, md: 10, lg: 10, xl: 10 }}>
            <Grid align="center" gutter={"xs"}>
              <Grid.Col span={sizeGrid}>
                <Input
                  size="sm"
                  placeholder="Từ khoá"
                  type="text"
                  leftSection={<IconSearch color="#15aabf" />}
                  key={formSeachInput.key("keySearch")}
                  {...formSeachInput.getInputProps("keySearch")}
                />
              </Grid.Col>
              {/* <Grid.Col span={sizeGrid}>
                <Select
                  key={`${formSeachInput.getValues().type}`}
                  size="sm"
                  placeholder="Chọn mức cấp"
                  searchable
                  clearable
                  leftSection={<IconChartArrowsVertical color="#15aabf" />}
                  data={[
                    { value: "1", label: "Mức 1" },
                    { value: "2", label: "Mức 2" },
                  ]}
                  {...formSeachInput.getInputProps("type")}
                />
              </Grid.Col> */}
              {/* <Grid.Col span={sizeGrid}>
                <Select
                  key={`${formSeachInput.getValues().empId}`}
                  placeholder="Nhập mã hoặc tên nhân viên"
                  data={dataEmployeeSelect}
                  searchable
                  clearable
                  onClick={() => {
                    if (dataEmployeeSelect.length === 0) {
                      getDataEmployee();
                    }
                  }}
                  leftSection={<IconUser color="#15aabf" />}
                  size="sm"
                  {...formSeachInput.getInputProps("empId")}
                />
              </Grid.Col> */}
              <Grid.Col span={sizeGrid}>
                <Button
                  type="submit"
                  leftSection={<IconSearch size={20} />}
                  color="blue"
                  variant="outline"
                  onClick={() => fetchData()}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 2, md: 2, lg: 2, xl: 2 }}>
            <Flex
              gap="md"
              align="center"
              justify={"flex-end"}
              direction="row"
              wrap="nowrap"
            >
              <Button
                leftSection={<IconPlus size={14} />}
                color="blue"
                variant="outline"
                onClick={async () => {
                  handleOpenModalCreate();
                }}
              >
                Thêm mới
              </Button>
              {/* <Button
                leftSection={<IconMinus size={14} />}
                color="red"
                variant="outline"
                onClick={async () => {
                  handleDelete(selectIds);
                }}
              >
                Xóa
              </Button> */}
            </Flex>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default ReturnTechnicalExchange;
